import React, { forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import AdminAccessManager from './AdminAccessManager';
import InternalAccessManager from './InternalAccessManager';

const AdvertiserAccessManager = forwardRef(
  (
    {
      user_role,
      userEmail,
      formData,
      setFormData,
      allUsersList,
      loadingUsers,
      usersListError,
      invitedUserExistingAccess,
      movedFromExisting,
      setMovedFromExisting,
      retryFetch,
      fetchAllUsersList,
      advertiserMetaDetails = [],
      onAdvertiserAdded,
      currentAccessData = {},
      currentUserAdvertisers = []
    },
    ref
  ) => {
    // Expose methods to parent component
    useImperativeHandle(ref, () => ({
      addRemovedAdvertiser: (advertiserName, timezone) => {
        // This will be handled by the specific access manager components
      },
      addRemovedOrganization: (orgName) => {
        // This will be handled by the specific access manager components
      }
    }));

    // Smart routing based on user role
    const renderAccessManager = () => {
      if (user_role === 'admin') {
        return (
          <AdminAccessManager
            ref={ref}
            userEmail={userEmail}
            formData={formData}
            setFormData={setFormData}
            advertiserMetaDetails={advertiserMetaDetails}
            onAdvertiserAdded={onAdvertiserAdded}
            currentAccessData={currentAccessData}
          />
        );
      } else if (user_role === 'internal') {
        return (
          <InternalAccessManager
            ref={ref}
            userEmail={userEmail}
            formData={formData}
            setFormData={setFormData}
            allUsersList={allUsersList}
            advertiserMetaDetails={advertiserMetaDetails}
            onAdvertiserAdded={onAdvertiserAdded}
            currentAccessData={currentAccessData}
            currentUserAdvertisers={currentUserAdvertisers}
          />
        );
      } else {
        return <div>Loading...</div>;
      }
    };

    // Render the appropriate access manager based on user role
    return renderAccessManager();
  }
);

AdvertiserAccessManager.propTypes = {
  user_role: PropTypes.string.isRequired,
  userEmail: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  allUsersList: PropTypes.array.isRequired,
  loadingUsers: PropTypes.bool,
  usersListError: PropTypes.string,
  invitedUserExistingAccess: PropTypes.array,
  movedFromExisting: PropTypes.array,
  setMovedFromExisting: PropTypes.func.isRequired,
  retryFetch: PropTypes.func.isRequired,
  fetchAllUsersList: PropTypes.func.isRequired,
  advertiserMetaDetails: PropTypes.array,
  onAdvertiserAdded: PropTypes.func,
  currentAccessData: PropTypes.object,
  currentUserAdvertisers: PropTypes.array
};

AdvertiserAccessManager.defaultProps = {
  loadingUsers: false,
  usersListError: '',
  invitedUserExistingAccess: [],
  movedFromExisting: [],
  currentAccessData: {},
  currentUserAdvertisers: []
};

export default AdvertiserAccessManager;
